import styles from './ChartSkeleton.module.scss';

const xAxisLabelCount = 6;
const yAxisLabelCount = 5;

const yAxisLabelKeys = Array.from({ length: yAxisLabelCount }, (_, index) => `y-axis-label-${index}`);
const xAxisLabelKeys = Array.from({ length: xAxisLabelCount }, (_, index) => `x-axis-label-${index}`);

const ChartSkeleton: React.FC = () => (
    <div className={styles.chart_skeleton}>
        <div className={styles.chart_skeleton_body}>
            <div className={styles.chart_skeleton_y_axis}>
                {yAxisLabelKeys.map((key) => (
                    <div key={key} className={styles.chart_skeleton_y_axis_label} />
                ))}
            </div>
            <div className={styles.chart_skeleton_plot_area}>
                <div className={styles.chart_skeleton_grid_line} />
                <div className={styles.chart_skeleton_grid_line} />
                <div className={styles.chart_skeleton_grid_line} />
                <div className={styles.chart_skeleton_grid_line} />
            </div>
        </div>
        <div className={styles.chart_skeleton_x_axis}>
            {xAxisLabelKeys.map((key) => (
                <div key={key} className={styles.chart_skeleton_x_axis_label} />
            ))}
        </div>
    </div>
);

export default ChartSkeleton;
